export const UMB_USER_GROUP_ENTITY_TYPE = 'user-group';
export const UMB_USER_GROUP_ROOT_ENTITY_TYPE = 'user-group-root';

export type UmbUserGroupEntityType = typeof UMB_USER_GROUP_ENTITY_TYPE;
export type UmbUserGroupRootEntityType = typeof UMB_USER_GROUP_ROOT_ENTITY_TYPE;
